import { useDecision } from '@optimizely/react-sdk'

const PRODUCT_DETAIL_MODAL_REFRESH_FLAG = 'turnips_ofx_product_detail_refresh'

export const useProductDetailRefresh = () => {
  const [featureFlagDecision] = useDecision(PRODUCT_DETAIL_MODAL_REFRESH_FLAG)

  return featureFlagDecision.variationKey === 't1'
}
